
import axios from 'axios'
// import { Loading } from 'tdesign-vue'
// import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from "@/utils/ruoyi";
import { saveAs } from 'file-saver'
import {getCoreUserId} from '@/utils/coreUserId'
import { MessagePlugin } from 'tdesign-vue';

// eslint-disable-next-line no-unused-vars
// let downloadLoadingInstance;
// create an axios instance
const service = axios.create({
  // 外网更新
  // baseURL: 'http://xxxxx',
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000 // request timeout
})

service.interceptors.request.use(
  config => {
    // 设置请求头部，允许跨域请求
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE'
    config.headers['Access-Control-Allow-Headers'] = 'Content-Type'

    // console.log('config',config)
    // console.log("config.url.split('/')",config.url.split('/').at(-1))
    if (config.method === "post" && config.url.split('/').at(-1) == 'ins'){
      // console.log('config.data',config.data)
      config.data.userId = getCoreUserId()
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // debugger
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    const msg = res.data.msg;
    console.log('code',res)
    if (code === 500) {
      MessagePlugin.error(msg);
      return Promise.reject(new Error(msg));
    }else if (code === 601) {
      MessagePlugin.warning(msg);
      return Promise.reject("error");
    } else if(code == 300){
      return res;
    } else if (code !== 200) {
      MessagePlugin.warning(msg);
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
    (error) => {
      console.log("err" + error);
      let { message } = error;
      if (message == "Network Error") {
        message = "后端接口连接异常";
      } else if (message.includes("timeout")) {
        message = "系统接口请求超时";
      } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
      }
      MessagePlugin.error(message);
      // Message({ message: message, type: "error", duration: 5 * 1000 });
      return Promise.reject(error);
    }

  )


// 通用下载方法
export function download(url, params, filename, config) {
  // downloadLoadingInstance = Loading.service({
  //   content: '调用关闭函数关闭信息提示框',
  //   duration: 0,
  //   // 层级控制：非当前场景自由控制开关的关键代码，仅用于测试 API 是否运行正常
  //   zIndex: 1001,
  //   // 挂载元素控制：非当前场景自由控制开关的关键代码，仅用于测试 API 是否运行正常
  //   attach: document.body,
  // })
  console.log('params', params)

  const hostname = window.location.hostname
  const isIPv4 = (host) => /^\d{1,3}(\.\d{1,3}){3}$/.test(host)
  const isLocalOrIp = hostname === 'localhost' || isIPv4(hostname)
  const isWordDownload = url.split('/').at(-1) === 'word'

  // 非 localhost / 非 IP（即域名访问）时，word 下载必须携带基础平台 userId
  if (isWordDownload && !isLocalOrIp) {
    const coreUserId = getCoreUserId()
    if (!coreUserId) {
      alert('请前往基础平台进行登录进入')
      window.location.href = "https://core.xingsnb.cn"
      return Promise.reject(new Error('Missing core userId'))
    }
    params.userId = coreUserId
  }
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    console.log('data',data)
    
    if (isBlob) {
      // console.log('isBlob',isBlob)
      const blob = new Blob([data])
      // console.log('blob',blob)
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      console.log('resText', resText)
      const rspObj = JSON.parse(resText);
      const errMsg =  rspObj.msg
      MessagePlugin.error(errMsg);
    }
    // this.$message.close(downloadLoadingInstance);
  }).catch(() => {
    // console.error(r)
    // Message.error('下载文件出现错误，请联系管理员！')
    
    // this.$message.close(downloadLoadingInstance);
    // downloadLoadingInstance.close();
  })
}

export default service
